import React, { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
export function PageTransition({
  children
}: {
  children: ReactNode;
}) {
  const reduceMotion = useReducedMotion();
  return <motion.div initial={{
    opacity: 0,
    y: reduceMotion ? 0 : 16
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: reduceMotion ? 0 : -10
  }} transition={{
    duration: reduceMotion ? 0.01 : 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-348" data-mp="2z2hgex3dklu2">
      {children}
    </motion.div>;
}